(() => {
  const getSections = (drawer) => {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return ['cart-drawer', 'cart-icon-bubble'];

    return drawer.getSectionsToRender().map((section) => section.id);
  };

  const setMessage = (button, message) => {
    const container = button.closest('.kronk-cart-upsells');
    const messageNode = container?.querySelector('[data-kronk-cart-upsell-message]');
    if (!messageNode) return;

    messageNode.textContent = message || '';
    messageNode.hidden = !message;
  };

  const setLoading = (button, isLoading) => {
    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-kronk-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const drawer = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', getSections(drawer).join(','));
    formData.append('sections_url', window.location.pathname);

    setMessage(button, '');
    setLoading(button, true);

    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'This item could not be added.');
      }

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'kronk-cart-upsell',
          productVariantId: variantId,
          cartData: data,
        });
      }
    } catch (error) {
      setMessage(button, error.message || 'This item could not be added. Please try again.');
    } finally {
      setLoading(button, false);
    }
  });
})();
